import dayjs from "dayjs";

require("dayjs/locale/de");
require("dayjs/locale/it");
require("dayjs/locale/fr");
require("dayjs/locale/es");
require("dayjs/locale/nl");

const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

const relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);

const localeData = require("dayjs/plugin/localeData");
dayjs.extend(localeData);

const updateLocale = require("dayjs/plugin/updateLocale");
dayjs.extend(updateLocale);

//@ts-expect-error
dayjs.updateLocale("en", {
    weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
});
//@ts-expect-error
dayjs.updateLocale("fr", {
    weekdaysShort: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
});
//@ts-expect-error
dayjs.updateLocale("nl", {
    weekdaysShort: ["zo", "ma", "di", "woe", "don", "vrij", "za"],
});
//@ts-expect-error
dayjs.updateLocale("it", {
    weekdaysShort: ["dom.", "lun.", "mar.", "mer.", "gio.", "ven.", "sab."],
});
//@ts-expect-error
dayjs.updateLocale("de", {
    weekdaysShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
});
//@ts-expect-error
dayjs.updateLocale("es", {
    weekdaysShort: ["Sab", "Lun", "Mar", "Mie", "Jue", "Vie", "Dom"],
    monthsShort: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sept",
        "oct",
        "nov",
        "dic",
    ],
});

export default dayjs;
